import { render, staticRenderFns } from "./share-type.vue?vue&type=template&id=213ba1dc&"
import script from "./share-type.vue?vue&type=script&lang=js&"
export * from "./share-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports